(function(){
  if (window.__mpnPdp) return; window.__mpnPdp = true;
  var mq = window.matchMedia('(max-width: 749.98px)');
  var de = document.documentElement;
  var ATC_RE = /ajouter au panier|add to cart|in den warenkorb/i;
  var SOLD_RE = /épuisé|epuise|sold out|ausverkauft|indisponible|unavailable|nicht verfügbar/i;
  var BIS_RE = /prévenez|prevenez|m'alerter|me prévenir|notify|benachrichtig|quand disponible|when available|wieder verfügbar/i;
  var COLOR_VARS = ['--color-background','--gradient-background','--color-foreground','--color-foreground-title','--color-background-contrast','--color-shadow','--color-button','--color-button-hover','--color-button-text','--color-button-text-hover','--color-button-border','--color-button-border-hover','--color-secondary-button','--color-secondary-button-hover','--color-secondary-button-text','--color-secondary-button-text-hover','--color-secondary-button-border','--color-secondary-button-border-hover','--color-link'];

  function hasShiftingAncestor(el){
    var p = el.parentElement;
    while (p && p !== document.body && p !== de) {
      var cs = getComputedStyle(p);
      if ((cs.transform && cs.transform !== 'none') || (cs.filter && cs.filter !== 'none') || (cs.perspective && cs.perspective !== 'none') || /transform|filter/.test(cs.willChange || '') || (cs.contain && /paint|layout|strict|content/.test(cs.contain))) return true;
      p = p.parentElement;
    }
    return false;
  }

  function keepColors(el){
    if (el.dataset.mpnColors) return;
    var cs = getComputedStyle(el);
    COLOR_VARS.forEach(function(v){
      var val = cs.getPropertyValue(v);
      if (val && val.trim()) el.style.setProperty(v, val.trim());
    });
    el.dataset.mpnColors = '1';
  }

  function fixStickyBars(){
    if (!mq.matches) return;
    var bars = [].slice.call(document.querySelectorAll('.sticky-container'));
    document.querySelectorAll('button, a, input[type=submit]').forEach(function(b){
      var txt = (b.textContent || b.value || '').trim();
      if (!ATC_RE.test(txt)) return;
      var el = b, n = 0;
      while (el && el !== document.body && n < 10) {
        if (getComputedStyle(el).position === 'fixed') { if (bars.indexOf(el) < 0) bars.push(el); return; }
        el = el.parentElement; n++;
      }
    });
    bars.forEach(function(el){
      if (el.closest('cart-drawer, dialog, .drawer, #CartDrawer')) return;
      el.classList.add('mpn-sticky-atc');
      if (el.parentNode !== document.body && hasShiftingAncestor(el)) {
        var formOk = !!el.querySelector('form') || !el.closest('form');
        if (formOk) {
          keepColors(el);
          el.querySelectorAll('.button, button').forEach(keepColors);
          document.body.appendChild(el);
        }
      }
      el.style.setProperty('position', 'fixed', 'important');
      el.style.setProperty('top', 'auto', 'important');
      el.style.setProperty('bottom', '0px', 'important');
      el.style.setProperty('left', '0px', 'important');
      el.style.setProperty('right', '0px', 'important');
      el.style.setProperty('margin', '0', 'important');
      el.style.setProperty('transform', 'none', 'important');
    });
    syncBis();
  }

  /* Produit epuise : la barre flottante reprend le bouton "Prevenez-moi" de l'appli */
  function isVisible(el){
    if (!el || !el.isConnected) return false;
    var r = el.getBoundingClientRect();
    if (r.width < 20 || r.height < 16) return false;
    var cs = getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity || '1') > 0.05;
  }
  function findBis(){
    var scope = document.querySelector('.product__info-container') || document.querySelector('main') || document;
    var found = null;
    scope.querySelectorAll('button, a, input[type=button], input[type=submit], [role=button]').forEach(function(b){
      if (found || b.closest('.mpn-sticky-atc')) return;
      var t = (b.textContent || b.value || '').replace(/\s+/g, ' ').trim();
      if (t && BIS_RE.test(t) && isVisible(b)) found = b;
    });
    return found;
  }
  function syncBis(){
    document.querySelectorAll('.mpn-sticky-atc').forEach(function(bar){
      var btn = bar.querySelector('[data-mpn-bis]') || bar.querySelector('button[type=submit], button[name=add], .product-form__submit, button.button, .button');
      if (!btn) return;
      var label = btn.querySelector('span') || btn;
      var txt = (btn.textContent || '').replace(/\s+/g, ' ').trim();
      var soldOut = btn.hasAttribute('data-mpn-bis') ? !ATC_RE.test(btn.dataset.mpnThemeTxt || '') : (btn.disabled || SOLD_RE.test(txt));
      if (btn.hasAttribute('data-mpn-bis')) {
        /* le theme a-t-il remis "Ajouter au panier" (variante disponible) ? */
        if (ATC_RE.test(txt) && !btn.disabled) { restore(btn); return; }
      }
      var bis = soldOut ? findBis() : null;
      if (!bis) { if (btn.hasAttribute('data-mpn-bis')) restore(btn); return; }
      var bisTxt = (bis.textContent || bis.value || '').replace(/\s+/g, ' ').trim();
      if (!btn.hasAttribute('data-mpn-bis')) {
        btn.dataset.mpnThemeTxt = txt;
        btn.setAttribute('data-mpn-bis', '1');
      }
      btn.__mpnBis = bis;
      btn.disabled = false;
      btn.removeAttribute('aria-disabled');
      if (label.textContent.trim() !== bisTxt) label.textContent = bisTxt;
      var cs = getComputedStyle(bis);
      btn.style.setProperty('background', cs.backgroundColor, 'important');
      btn.style.setProperty('color', cs.color, 'important');
      btn.style.setProperty('border-color', cs.borderColor, 'important');
      if (label !== btn) label.style.setProperty('color', cs.color, 'important');
    });
  }
  function restore(btn){
    btn.removeAttribute('data-mpn-bis');
    ['background', 'color', 'border-color'].forEach(function(p){ btn.style.removeProperty(p); });
    var label = btn.querySelector('span');
    if (label) label.style.removeProperty('color');
    btn.__mpnBis = null;
  }
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('.mpn-sticky-atc [data-mpn-bis]');
    if (!b) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var bis = (b.__mpnBis && b.__mpnBis.isConnected) ? b.__mpnBis : findBis();
    if (bis) bis.click();
  }, true);

  /* Barre flottante "Ajouter au panier" (mobile ET ordinateur) : un clic ramene au choix (format, palette,
     surface) au lieu d'ajouter 1 unite au panier (oct. 2026, demande d'Ed). L'ajout se fait avec le vrai bouton de la fiche. */
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('.mpn-sticky-atc button, .mpn-sticky-atc .button, .mpn-sticky-atc input[type=submit], .sticky-container button, .sticky-container .button, .sticky-container input[type=submit]');
    if (!b || b.hasAttribute('data-mpn-bis')) return;
    var c = document.querySelector('.product__info-container');
    var tgt = null;
    if (c) {
      var cands = [c.querySelector('.mpn-fmt__step'), c.querySelector('[data-mpn-pal]:not([hidden])'), c.querySelector('quantity-calculator'), c.querySelector('.product-buy-buttons__wrapper')];
      for (var i = 0; i < cands.length; i++) { if (cands[i] && cands[i].getBoundingClientRect().height > 0) { tgt = cands[i]; break; } }
    }
    if (!tgt) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var off = 16, hd = document.querySelector('sticky-header') || document.querySelector('.header-wrapper');
    if (hd) { var hr = hd.getBoundingClientRect(); if (hr.bottom > 0 && hr.top <= 0) off += hr.bottom; }
    window.scrollTo({ top: Math.max(0, tgt.getBoundingClientRect().top + (window.pageYOffset || 0) - off), behavior: 'smooth' });
  }, true);

  function onScroll(){ de.classList.toggle('mpn-pdp-scrolled', (window.scrollY || window.pageYOffset || 0) > 300); }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  var watched = [], visible = new Set();
  function isInFixed(el){
    var p = el;
    while (p && p !== document.body) { if (p.classList && p.classList.contains('mpn-sticky-atc')) return true; if (getComputedStyle(p).position === 'fixed') return true; p = p.parentElement; }
    return false;
  }
  function watchMain(){
    if (!('IntersectionObserver' in window)) return;
    var targets = [].slice.call(document.querySelectorAll('quantity-calculator, .product-buy-buttons__wrapper')).filter(function(el){
      return watched.indexOf(el) < 0 && !isInFixed(el);
    });
    if (!targets.length) return;
    if (!watchMain.io) {
      watchMain.io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if (en.isIntersecting) visible.add(en.target); else visible.delete(en.target); });
        visible.forEach(function(el){ if (!el.isConnected) visible.delete(el); });
        de.classList.toggle('mpn-main-atc-visible', visible.size > 0);
      }, { rootMargin: '0px 0px -60px 0px' });
    }
    targets.forEach(function(el){ watched.push(el); watchMain.io.observe(el); });
  }

  function setup(){
    if (!mq.matches) return;
    document.querySelectorAll('media-gallery .product__media-list').forEach(function(list){
      if (list.__mpnBound) return;
      var host = list.closest('slider-component');
      if (!host) return;
      var n = list.querySelectorAll('.product__media-item').length;
      if (n < 2) return;
      list.__mpnBound = true;
      var bar = document.createElement('div'); bar.className = 'mpn-pdp-progress'; bar.setAttribute('aria-hidden', 'true'); bar.appendChild(document.createElement('span')); host.appendChild(bar);
      bar.style.setProperty('--n', n);
      var raf = 0;
      /* Filet de securite : si une photo s'arrete a mi-chemin (glissement saccade sur iPhone),
         on la recale en douceur sur la plus proche, une fois le doigt leve et le defilement arrete. */
      var touching = false, settleT = 0;
      function settle(){
        if (touching) return;
        var w = list.clientWidth || 1, sl = list.scrollLeft, k = Math.round(sl / w);
        if (Math.abs(sl - k * w) > 2) list.scrollTo({ left: k * w, behavior: 'smooth' });
      }
      list.addEventListener('touchstart', function(){ touching = true; clearTimeout(settleT); }, { passive: true });
      list.addEventListener('touchend', function(){ touching = false; clearTimeout(settleT); settleT = setTimeout(settle, 180); }, { passive: true });
      list.addEventListener('touchcancel', function(){ touching = false; }, { passive: true });
      list.addEventListener('scroll', function(){ clearTimeout(settleT); settleT = setTimeout(settle, 160); }, { passive: true });
      list.addEventListener('scroll', function(){
        if (raf) return;
        raf = requestAnimationFrame(function(){
          raf = 0;
          var i = Math.round(list.scrollLeft / (list.clientWidth || 1));
          bar.style.setProperty('--i', Math.max(0, Math.min(n - 1, i)));
        });
      }, { passive: true });
    });
  }

  function isPriceBlock(k){ return !!(k.id && (k.id.indexOf('variant-price-summary-') === 0 || k.id.indexOf('price-') === 0)); }
  function hasVisibleContent(el){
    if ((el.innerText || '').replace(/\s+/g, '').length > 0) return true;
    var media = el.querySelectorAll('img,svg,video,iframe,canvas,picture,input:not([type=hidden]),button,shopify-payment-terms');
    for (var i = 0; i < media.length; i++) {
      var r = media[i].getBoundingClientRect();
      if (r.width > 4 && r.height > 4) return true;
    }
    return false;
  }
  function tidy(){
    if (!mq.matches) return;
    document.querySelectorAll('.product__info-container').forEach(function(c){
      var kids = [].slice.call(c.children);
      var start = -1;
      kids.forEach(function(k, i){ if (start < 0 && isPriceBlock(k)) start = i; });
      if (start < 0) return;
      kids.forEach(function(k){ k.classList.remove('mpn-after-price'); });
      for (var j = start + 1; j < kids.length; j++) {
        var k = kids[j];
        if (k.tagName === 'SCRIPT' || k.tagName === 'STYLE' || k.tagName === 'TEMPLATE' || k.tagName === 'LINK') continue;
        k.classList.remove('mpn-empty');
        if (hasVisibleContent(k)) { k.classList.add('mpn-after-price'); break; }
        k.classList.add('mpn-empty');
      }
    });
  }
  var t;
  function schedule(){ clearTimeout(t); t = setTimeout(tidy, 150); }
  function init(){
    setup(); tidy(); fixStickyBars(); watchMain();
    document.querySelectorAll('.product__info-container').forEach(function(c){
      new MutationObserver(function(muts){
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].type === 'attributes' && muts[i].attributeName === 'class' && muts[i].target.parentNode === c) continue;
          schedule(); watchMain(); return;
        }
      }).observe(c, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', function(){ tidy(); fixStickyBars(); watchMain(); });
  window.addEventListener('scroll', function(){ if (!fixStickyBars.raf) fixStickyBars.raf = setTimeout(function(){ fixStickyBars.raf = 0; fixStickyBars(); }, 250); }, { passive: true });
  setInterval(fixStickyBars, 1000);
  if (mq.addEventListener) mq.addEventListener('change', tidy);
})();
